<template>
  <div v-if="promo">
    <PassChoice :normalProducts="[promo.product]">
      <template #title>
        <h2>Offre exceptionelle sur le Pass <colored-name /></h2>
      </template>

      <template #description>
        <div>
          <img src="/assets/icons/paiement/illimite.png" />
          Je peux lire et envoyer un nombre <strong>ILLIMITÉ</strong> de messages sur <colored-name />!
        </div>
        <div>
          <img src="/assets/icons/paiement/message.png" />
          <strong> TOUS LES MEMBRES d'</strong><colored-name /> peuvent me lire et me répondre
          <strong>GRATUITEMENT</strong>!
        </div>
        <p>
          <br />
          Dans le cadre de cette offre, je bénéficie en plus des avantages liés à l'option
          <strong>Pass <span class="serenite">Sérénité</span></strong> !
        </p>
        <div>
          <img class="iconesSerenite" src="/assets/icons/paiement/filtre.png" />Le filtre de contacts me permet d'être
          contacté(e) uniquement par les membres qui vous plaisent par critère de sexe, d'âge, de région...
        </div>
        <div>
          <img class="iconesSerenite" src="/assets/icons/paiement/visite.png" />Je peux voir date de dernière connexion
          (approximative) des autres membres.
        </div>
        <div>
          <img class="iconesSerenite" src="/assets/icons/paiement/message.png" />Je suis informé(e) de la réception de
          votre message par votre interlocuteur (accusé de réception des messages).
        </div>
        <div>
          <img class="iconesSerenite" src="/assets/icons/paiement/parametre.png" />Je peux naviguer en toute discrétion.
          Je peux me rendre invisible sur le site, tout en pouvant communiquer avec les membres.
        </div>
        <p>
          Les fonctionnalités Filtre de contact et mode invisible sont accessibles dans le menu
          <strong>Mon Compte / Confidentialité </strong>
        </p>

        <div>
          <img :src="promo.image" class="promo largePromo" />
        </div>
      </template>
    </PassChoice>
  </div>
</template>

<script>
import BasePage from "@/components/pages/BasePage";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import PassChoice from "../pass/PassChoice.vue";
import ColoredName from "@/components/util/ColoredName";

export default {
  extends: BasePage,
  name: "Pass",
  components: { PassChoice, ColoredName },

  data() {
    return {
      promo: null,
      normalProducts: null,
      aahProducts: null,
      selectedProduct: null,
      aah: false
    };
  },

  methods: {
    init: async function() {
      this.promo = this.$store.state.promo;
      this.$store.state.promo = null;
      this.normalProducts = await idyuJsonRpc("getPassInformation");
      this.aahProducts = await idyuJsonRpc("getAAHPassInformation");
    }
  }
};
</script>

<style scoped lang="scss">
.promo {
  max-width: 800px;
}

.smallPromo {
  display: none;
  max-width: 400px;
}

.largePromo {
  display: block;
}

@media screen and (max-width: 840px) {
  .largePromo {
    display: none;
  }
}
</style>
